module.exports = __webpack_public_path__ + "47cde550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_singtao@2x.png
// module id = 1195
// module chunks = 0